package ru.education.building.navigation.routes

import androidx.compose.animation.EnterTransition
import androidx.compose.animation.ExitTransition
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import moe.tlaster.precompose.navigation.NavHost
import moe.tlaster.precompose.navigation.Navigator
import moe.tlaster.precompose.navigation.transition.NavTransition
import ru.education.building.schedule.SchedulePage
import ru.education.building.settings.SettingsPage


@Composable
fun AppNavigation(navigator: Navigator, paddingValues: PaddingValues) {
    NavHost(
        navigator = navigator,
        navTransition = NavTransition(
            createTransition = EnterTransition.None,
            destroyTransition = ExitTransition.None,
            resumeTransition = EnterTransition.None,
            pauseTransition = ExitTransition.None,
        ),
        initialRoute = "/",
        modifier = Modifier
            .fillMaxSize()
            .padding(paddingValues)
    ) {
        scene(route = "/") {
            SchedulePage()
        }
        scene(route = "/settings") {
            SettingsPage()
        }
        scene(route = "/favorites") {
            Text("favorites")
        }
        scene(route = "/profile") {
            Text("profile")
        }
    }
}
